import {
  build_default_content,
  build_info_banner_block,
  build_point_list_block,
  get_site_config,
  POINT_LIST_BLOCK,
} from "./utilities";

export const liveflight_sections = (config = {}) => {
  const items = build_default_content(config)
    .filter((block) => block.type !== POINT_LIST_BLOCK)
  return [...items, build_point_list_block([
    {
        pl_icon: "airplane",
        pl_title: "Vola in tutto il mondo",
        pl_text:
          "Siamo un’agenzia IATA, con accordi diretti con le migliori compagnie aeree",
      },
      {
        pl_icon: "happy_pin",
        pl_title: "Per il welfare aziendale",
        pl_text:
          "Prenota direttamente con il tuo credito welfare, senza usare la tua carta",
      },
      {
        pl_icon: "hands",
        pl_title: "Assistenza dedicata",
        pl_text:
          "Hai a disposizione un servizio clienti esclusivo e agenti di viaggio dedicati",
      }
  ])]
};

export const liveflight_sections_visitor = (config = {}) => {
  const { brand, payoff } = get_site_config(config);
  return [
    build_info_banner_block({
      image: "/assets/images/liveflight/homepage/prenota-con-welfare.png",
      title: "Prenota un volo col credito welfare",
      description: `<p class="section--welfare-text">
                  Con <strong>${payoff} ${brand}</strong> prenoti
                  online in tempo reale con il tuo <strong>credito welfare</strong>.<br />
                  Potrai prenotare il tuo viaggio in <strong>pochi click</strong> scegliendo tra le maggiori
                  compagnie aeree, sia di linea che low cost.<br /><br />
                  <strong>1 - Accedi a ${payoff} dal tuo portale welfare</strong><br />
                  <strong>2 - Cerca e prenota il tuo volo in pochi click</strong><br /><br />
                  Il pagamento avverrà tramite <strong>addebito diretto sul tuo credito welfare</strong>:
                  nessun voucher, nessun codice da creare.<br />
                  Ti serve aiuto con l'utilizzo del credito welfare?
                  <strong>Contatta la nostra assistenza!</strong>
                </p>`,
    }),
    build_info_banner_block({
      image: "/assets/images/liveeps/statics/iStock-1208856002.jpg",
      title: "Hai un buono da utilizzare su Flight easy Vadobay?",
      description: `Senza passare dal portale welfare, con il buono puoi accedere direttamente al nostro sito! Clicca sul bottone qui sotto "Ho un buono" e inserisci il codice che hai ricevuto e i tuoi dati personali. In questo modo potrai accedere, effettuare una ricerca e prenotare subito il tuo volo!`,
      more_link: {
        to: "/ho-un-buono",
        text: "Accedi con un buono",
      },
    }),
  ];
};
